module.exports = ".ng-valids {\r\n  border-color: #42A948; /* green */\r\n}\r\n\r\n.ng-invalids:not(form) {\r\n  border-color: #a94442; /* red */\r\n}\r\n"